document.addEventListener("alpine:init", () => {
  const reviewsTab = document.querySelector("#reviews");
  const sortingSelect = reviewsTab.querySelector(
    ".wd-reviews-sorting-select-custom"
  );

  const urlParams = new URLSearchParams(window.location.search);
  const initialRating = urlParams.get("rating")
    ? parseInt(urlParams.get("rating"), 10)
    : null;
    
  Alpine.data("reviewsWidget", () => ({
    showReviewForm: false,
    ratingsSummary: [],
    averageRating: 0,
    reviewCount: 0,
    translations: {},
    selectedRating: initialRating,

    init(data) {
      const { ratingsSummary, averageRating, reviewCount, translations } =
        data || {};
      this.ratingsSummary = ratingsSummary || [];
      this.averageRating = averageRating || 0;
      this.reviewCount = reviewCount || 0;
      this.translations = translations || {};
      
    },

    toggleForm() {
      this.showReviewForm = !this.showReviewForm;
    },

    filterByRating(rating, clear = false, loaderForSummaryWrap = false, page = 1) {

      this.selectedRating = clear ? null : rating;

      let commentList = document.querySelector(".commentlist");
      let attr = commentList
        ? commentList.getAttribute("data-reviews-columns")
        : {};
      let animationTime = 50;

      let data = {
        action: "woodmart_blog_filter_review",
        rating: this.selectedRating || "",
        post_id: reviewsTab.getAttribute("data-post-id"),
        order_by: sortingSelect ? sortingSelect.value : "newest",
        only_images:
          document.querySelector("#wd-with-image-checkbox")?.checked || false,
        summary_criteria_ids: woodmart_settings.summary_criteria_ids,
        // cpage: page,
      };

      if (typeof attr === "string") {
        try {
          attr = JSON.parse(attr);
        } catch (e) {
          console.error("Invalid JSON format:", attr);
          attr = {};
        }
      }

      [
        "reviews_columns_tablet",
        "reviews_columns_mobile",
        "reviews_columns",
      ].forEach((key) => {
        if (key in attr) {
          data[key] = attr[key];
        }
      });
      
      if (clear) {
        data["rating"] = "";
        data["only_images"] = false;
      }

      let commentLists = reviewsTab.querySelector(
        "#custom-comments .commentlist"
      );

      reviewsTab
        .querySelector("#custom-comments .wd-loader-overlay")
        .classList.add("wd-loading");

      if (loaderForSummaryWrap) {
        reviewsTab
          .querySelector(".wd-rating-summary-wrap .wd-loader-overlay")
          .classList.add("wd-loading");
      }

      if (commentLists) {
        commentLists.classList.remove("wd-active", "wd-in");
      }

      fetch(woodmart_settings.ajaxurl + "?" + new URLSearchParams(data), {
        method: "GET",
      })
        .then((response) => {
          // Kiểm tra nếu không thành công thì ném lỗi
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.json();
        })
        .then((result) => {
          // Xử lý thành công
          reviewsTab
            .querySelector("#custom-comments .wd-loader-overlay")
            .classList.remove("wd-loading");

          if (loaderForSummaryWrap) {
            reviewsTab
              .querySelector(".wd-rating-summary-wrap .wd-loader-overlay")
              .classList.remove("wd-loading");
          }

          setTimeout(() => {
            reviewsTab
              .querySelector("#custom-comments .commentlist")
              .classList.add("wd-active");
          }, animationTime);

          setTimeout(() => {
            reviewsTab
              .querySelector("#custom-comments .commentlist")
              .classList.add("wd-in");
          }, animationTime * 2);

          if (!data.rating ?? !data.only_images) {
            document
              .querySelector(".wd-reviews-sorting-clear")
              .classList.add("wd-hide");
          }

          if (result.title) {
            reviewsTab.querySelector(".woocommerce-Reviews-title").innerHTML =
              result.title;
          }

          document.dispatchEvent(
            new CustomEvent("woodmart_reviews_sorting_clear", { detail: data })
          );

          if (result.content) {
            reviewsTab.querySelector(
              "#custom-comments .wd-reviews-content"
            ).innerHTML = result.content;
          }

          if (
            woodmartThemeModule.hasOwnProperty("photoswipeImages") &&
            typeof woodmartThemeModule.photoswipeImages === "function"
          ) {
            woodmartThemeModule.photoswipeImages();
          }

          if(rating) {
            document.querySelector(".wd-reviews-sorting-clear").classList.remove("wd-hide");
          }
        })
        .catch((error) => {
          // Xử lý lỗi
          console.error(error);
        })
        .finally(() => {
          // Luôn thực thi sau khi hoàn tất
          reviewsTab
            .querySelector("#custom-comments .wd-loader-overlay")
            .classList.remove("wd-loading");

          if (loaderForSummaryWrap) {
            reviewsTab
              .querySelector(".wd-rating-summary-wrap .wd-loader-overlay")
              .classList.remove("wd-loading");
          }
        });
    },

    clearFilter(event) {
        event.stopImmediatePropagation();
        this.filterByRating(null, true);
    },

    sortingListener() {
      this.filterByRating(this.selectedRating || "");
    },
  }));

  // Pagination AJAX Handler
  // document.addEventListener("click", (event) => {
  //   if (event.target.closest(".woocommerce-pagination.ajax-pagination a")) {
  //     event.preventDefault();
  //     let pageNum = parseInt(event.target.textContent.trim(), 10) || 1;
  //     const reviewsWidgetScope = Alpine.$data(reviewsTab);
  //     if (reviewsWidgetScope) {
  //       reviewsWidgetScope.filterByRating(reviewsWidgetScope.selectedRating || "", false, false, pageNum);
  //     } else {
  //       console.error("reviewsWidget scope not found!");
  //     }`
  //   }
  // });

  Alpine.data("starRating", () => ({
    selectedRating: null,

    selectRating(rating) {
      this.selectedRating = rating;
      document.getElementById("rating").value = rating;
    },
  }));
});
